// extracted by mini-css-extract-plugin
export default {"popupBody":"popupBody--UL62c","title":"title--YmfbW","subTitle":"subTitle--S3mP6"};